import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'components/atoms'
import { BufferingIcon, MuteIcon, PauseIcon, PlayIcon, UnmuteIcon } from 'assets/icons'
import useVideoPlayer from 'hooks/useVideoPlayer'
import { theme } from 'utils/theme'
import * as S from './styled'

const VideoPlayer = ({ video, contentType, contentId }) => {
  const videoElement = useRef(null)
  const [durationLoaded, setDurationLoaded] = useState(false)
  const [isControlsShown, setIsControlsShown] = useState(true)
  const { playerState, togglePlay, handleOnTimeUpdate, handleVideoProgress, toggleMute } = useVideoPlayer(
    videoElement,
    contentType,
    contentId,
    video
  )

  const formatTime = s => {
    let m = Math.floor(s / 60)
    m = m >= 10 ? m : '0' + m
    s = Math.floor(s % 60)
    s = s >= 10 ? s : '0' + s
    return m + ':' + s
  }

  const handleControls = () => {
    setIsControlsShown(true)
    setTimeout(() => setIsControlsShown(false), 5000)
  }

  useEffect(() => {
    videoElement.current.ondurationchange = function () {
      setDurationLoaded(true)
      setIsControlsShown(true)
    }
  }, [])

  useEffect(() => {
    setDurationLoaded(false)
    setIsControlsShown(true)
  }, [video])

  return (
    <S.VideoWrapper>
      <S.VideoContainer onClick={handleControls}>
        <video src={video} ref={videoElement} onTimeUpdate={handleOnTimeUpdate} />
        {durationLoaded ? (
          <S.TogglePlay onClick={togglePlay} isControlsShown={isControlsShown}>
            <S.TogglePlayIconWrapper>
              {!playerState.isPlaying ? (
                <Icon Source={PlayIcon} width='36px' height='41px' color='#000000' />
              ) : (
                <Icon Source={PauseIcon} width='36px' height='41px' color='#000000' />
              )}
            </S.TogglePlayIconWrapper>
          </S.TogglePlay>
        ) : (
          <S.Buffering>
            <Icon Source={BufferingIcon} width='50px' height='50px' color='rgba(255,255,255,0.2)' />
          </S.Buffering>
        )}
      </S.VideoContainer>
      {durationLoaded && (
        <S.VideoControls
          isControlsShown={isControlsShown}
          onTouchMove={() => setIsControlsShown(true)}
          onTouchEnd={handleControls}
        >
          <S.Actions>
            <S.Duration>
              {!Number.isNaN(videoElement.current?.currentTime) &&
                !Number.isNaN(videoElement.current?.duration) &&
                `${formatTime(videoElement.current?.currentTime)} / ${formatTime(videoElement.current?.duration)}`}
            </S.Duration>

            <input type='range' min='0' max='100' value={playerState.progress} onChange={e => handleVideoProgress(e)} />
            <div onClick={toggleMute}>
              {!playerState.isMuted ? (
                <Icon Source={UnmuteIcon} width='24px' height='24px' color={theme.colors.white} />
              ) : (
                <Icon Source={MuteIcon} width='24px' height='24px' color={theme.colors.white} />
              )}
            </div>
          </S.Actions>
        </S.VideoControls>
      )}
    </S.VideoWrapper>
  )
}

VideoPlayer.defaultProps = {}

VideoPlayer.propTypes = {
  video: PropTypes.string.isRequired,
  contentType: PropTypes.string.isRequired,
  contentId: PropTypes.string.isRequired,
}

export default VideoPlayer
